export default __webpack_public_path__ + "static/media/Power_MKozłowska-kopia.96be731e.pdf";